import cn from "classnames";
import "./Tooltip.scss";

const Tooltip = ({ text, className, showTooltip = false }) => {
  if (!showTooltip) {
    return null;
  }

  return (
    <div className={cn("tooltip", [className])}>
      <div>{text}</div>
    </div>
  );
};

export default Tooltip;
